@if (mapItem().provider) {
    <ui-detail-section title="Kontakt aufnehmen mit:">
        <div class="prevention-contact">
            <div class="prevention-contact__row">
                <div class="prevention-contact__col">
                    <ui-detail-description
                        [title]="'Anbieter/in (Institution):'"
                        [htmlDescription]="mapItem().provider.title"
                    />

                    @if (mapItem().provider.address; as address) {
                        <ui-detail-address
                            [title]="'Adresse:'"
                            [text]="address"
                        />
                    }

                    @if (mapItem().provider.website; as website) {
                        <ui-detail-weblink
                            [title]="'Website des Anbieters:'"
                            [link]="website"
                        />
                    }

                    @if (mapItem().website; as website) {
                        <ui-detail-weblink
                            [title]="'Website des Angebots:'"
                            [link]="website"
                        />
                    }
                </div>

                <div class="prevention-contact__col">
                    @if (mapItem().provider.contactPerson; as person) {
                        <ui-detail-description
                            [title]="'Ansprechperson:'"
                            [htmlDescription]="person"
                        />
                    }

                    @if (mapItem().provider.phone; as phone) {
                        <ui-detail-phone-link
                            [title]="'Telefon:'"
                            [phone]="phone"
                        />
                    }
                    @if (mapItem().provider.email; as email) {
                        <ui-detail-email-link
                            [title]="'E-Mail:'"
                            [email]="email"
                        />
                    }
                </div>
            </div>
        </div>
    </ui-detail-section>
}
